import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { EulaPageComponent } from "./eula-page.component";

export const eulaPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-eula-page", EulaPageComponent)
    .atUrl("/customer-license-agreement")
    .requiresLogin(false)
    .build();
